import compact from 'lodash/compact';
import { ListBooking } from 'types';
import { ItemLinkProps } from '../../../Components/ItemLinks/ItemLink';
import { generateViewBookingDetailsItemLink } from '../generateViewBookingDetailsItemLink';
import { generateUpdatePaymentMethodItemLink } from '../generateUpdatePaymentMethodItemLink';

export const generateActionItemLinks = (booking: ListBooking, onTrack: () => void): ItemLinkProps[] => {
  const detailsLink = generateViewBookingDetailsItemLink(booking, onTrack);
  const updatePaymentMethodLink = generateUpdatePaymentMethodItemLink(booking);

  return compact([detailsLink, updatePaymentMethodLink]);
};
